{
  "version": 1,
  "packages": [
    { "id": "starter", "nameKey": "coinPack.starter", "coins": 100, "priceIrt": 10000, "priceUsdCents": 10 },
    { "id": "warmup", "nameKey": "coinPack.warmup", "coins": 250, "priceIrt": 25000, "priceUsdCents": 25 },
    { "id": "table", "nameKey": "coinPack.table", "coins": 600, "priceIrt": 60000, "priceUsdCents": 60 },
    { "id": "royal", "nameKey": "coinPack.royal", "coins": 1400, "priceIrt": 140000, "priceUsdCents": 140 },
    { "id": "legend", "nameKey": "coinPack.legend", "coins": 3200, "priceIrt": 320000, "priceUsdCents": 320 },
    { "id": "master", "nameKey": "coinPack.master", "coins": 7500, "priceIrt": 750000, "priceUsdCents": 750 }
  ]
}
